import * as THREE from "three";
import { OBJLoader } from "three/addons/loaders/OBJLoader.js";

window.THREE = THREE;
window.THREE_OBJLoader = OBJLoader;
